module.exports = __webpack_public_path__ + "fbdb12ea369903ca1f1056cf3219b8a5.fbx";